export class WebLead {

  private _name: string = null;
  private _surname: string = null;
  private _legalRefType?: string;
  private _idNumber: string = null;
  private _cellPhone: string = null;
  private _email: string = null;
  private _platform: string = null;
  private _campaign: string = null;
  private _error: string = null;
  private _originNode: string = null;
  private _medium: string = null;
  private _comment: string = null;
  private _fbClickID: string = null;
  private _fbBrowserID: string = null;
  private _urlParams: string = null;

  constructor() {
  }

  get urlParams(): string {
    return this._urlParams;
  }

  set urlParams(value: string) {
    this._urlParams = value;
  }
  get originNode(): string {
    return this._originNode;
  }

  set originNode(value: string) {
    this._originNode = value;
  }

  get error(): string {
    return this._error;
  }

  set error(value: string) {
    this._error = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get surname(): string {
    return this._surname;
  }

  set surname(value: string) {
    this._surname = value;
  }

  get legalRefType(): string {
    return this._legalRefType;
  }

  set legalRefType(value: string) {
    this._legalRefType = value;
  }

  get idNumber(): string {
    return this._idNumber;
  }

  set idNumber(value: string) {
    this._idNumber = value;
  }

  get cellPhone(): string {
    return this._cellPhone;
  }

  set cellPhone(value: string) {
    this._cellPhone = value;
  }

  get email(): string {
    return this._email;
  }

  set email(value: string) {
    this._email = value;
  }

  get platform(): string {
    return this._platform;
  }

  set platform(value: string) {
    this._platform = value;
  }

  get campaign(): string {
    return this._campaign;
  }

  set campaign(value: string) {
    this._campaign = value;
  }

  get medium(): string {
    return this._medium;
  }

  set medium(value: string) {
    this._medium = value;
  }

  get comment(): string {
    return this._comment;
  }

  set comment(value: string) {
    this._comment = value;
  }

  get fbBrowserID(): string {
    return this._fbBrowserID;
  }

  set fbBrowserID(value: string) {
    this._fbBrowserID = value;
  }
  get fbClickID(): string {
    return this._fbClickID;
  }

  set fbClickID(value: string) {
    this._fbClickID = value;
  }
}
